import { Component, OnInit } from '@angular/core';
import { User } from 'src/app/model/session/user.model';
import { SessionSotrageService } from '../../../../services/session-sotrage.service';
declare var $: any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {

  public user: User;
  perfil:any;

  constructor(private sssotrage: SessionSotrageService) { }

  ngOnInit() {
    this.user = this.sssotrage.getCurrentUser();
    this.perfil = this.user.perfil;
  }

  cerrarSesion(): void {
    this.sssotrage.logout();
  }
}
